import { Component, HostListener } from "@angular/core";

@Component({
  selector: "app-application-menu",
  templateUrl: "./application-menu.component.html",
  styleUrl: "./application-menu.component.scss",
  standalone: false
})
export class ApplicationMenuComponent {
  isOpen = false;

  /**
   * Handles document click events.
   * If the menu is open, it toggles the menu to close it.
   *
   * @param event The click event object.
   */
  @HostListener("document:click", ["$event"])
  handleDocumentClick(): void {
    if (this.isOpen) {
      this.toggle();
    }
  }

  /**
   * Toggles the menu open or closed.
   */
  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  /**
   * Handles click events on the menu.
   * Stops the propagation of the click event to prevent closing the menu.
   *
   * @param event The mouse event object.
   */
  menuClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}
